module.exports = __webpack_public_path__ + "img/CPTemp11.e10e05eb.png";